import React from 'react';
import { SectionHeading } from './SectionHeading';
import type { ProductBenefit } from '../../types/product';
type BenefitCardsProps = {
  heading: string;
  items: ProductBenefit[];
};
export function BenefitCards({
  heading,
  items
}: BenefitCardsProps) {
  return <section className="w-full bg-white py-20" aria-labelledby="benefits-heading" data-id="element-1026" data-mp="2wq5o2m53cxx8">
      <div className="mx-auto max-w-shell px-6" data-id="element-1027" data-mp="2rs46y6r878oe">
        <SectionHeading id="benefits-heading" title={heading} data-id="element-1028" data-mp="35sew95cw0f7g" />
        <ul className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-1029" data-mp="35qu39k6814bp">
          {items.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex flex-col rounded-[14px] bg-canvas-sky p-7" data-id="element-1030" data-mp="3fhoruv6xwg0b">
                <span className="flex h-11 w-11 items-center justify-center rounded-[10px] border border-canvas-line bg-white text-brand" data-id="element-1031" data-mp="3al807r0j7jih">
                  <Icon className="h-5 w-5" strokeWidth={1.8} aria-hidden="true" data-id="element-1032" data-mp="3petban9ehxdf" />
                </span>
                <h3 className="mt-6 text-[19px] font-semibold tracking-[-0.02em] text-ink" data-id="element-1033" data-mp="1y8iu836306mh">{item.title}</h3>
                <p className="mt-2 text-[15px] leading-[1.55] text-ink-muted" data-id="element-1034" data-mp="237c7buhghvm4">{item.copy}</p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}